import { Button } from "antd";
import { useCallback } from "react";
import { useHttp } from "../../../hooks/useHttp";
import { useErrorNotification } from "./useErrorNotification";
import { useNotification } from "~hooks/useNotification";

const AddVenueToSeasonButton = ({ sport, organizationId, seasonId, venueId, reloadData, pageRef }) => {
  const { loading, error, request, cleanError } = useHttp();

  useErrorNotification(error, cleanError, "Error occurred while submitting venue");
  const notification = useNotification();

  const submitVenueToSeason = useCallback(() => {
    request({
      url: `/v1/${sport}/o/${organizationId}/seasons/${seasonId}/venues`,
      method: "POST",
      body: {
        status: "ACTIVE",
        venueId: venueId,
      },
    }).then((res) => {
      if (reloadData) {
        reloadData();
      }

      notification.success({
        message: "Successfully submitted venue",
        placement: "bottomRight",
      });
    });
  }, [sport, organizationId, venueId, seasonId, reloadData, request, pageRef]);

  return <Button onClick={submitVenueToSeason} loading={loading} icon={<i className="fas fa-plus"/>} size="small"/>;
};

export default AddVenueToSeasonButton;
